import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import Peer, { DataConnection, MediaConnection, PeerJSOption } from 'peerjs';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { DeviceDetectorService } from "ngx-device-detector";
import { VideoAppointmentsData } from '../../../interfaces/patient-services/videoAppointment';
import { takeUntil } from 'rxjs/operators';


@Injectable()
export class CallService {
 
    public data:any=[  ];
 
    public local_mic_switch:boolean = true;
    public local_video_switch:boolean = true;

    public remote_mic_switch:boolean = true;
    public remote_video_switch:boolean = true;

    public camaraAllow=false;
    public cameraNallow=false;

    protected readonly unsubscribe$ = new Subject<void>();

    private its_host:boolean=false;
    sec_call=0;
    private peer: Peer;
    private peer_reconnect: Peer;
    private mediaCall: MediaConnection;
    private con:DataConnection;
    localstream;
    callstart:boolean=false;
    private localStreamBs: BehaviorSubject<MediaStream> = new BehaviorSubject(null);
    public localStream$ = this.localStreamBs.asObservable();

    remotestream;
    private remoteStreamBs: BehaviorSubject<MediaStream> = new BehaviorSubject(null);
    public remoteStream$ = this.remoteStreamBs.asObservable();

    private isCallStartedBs = new Subject<boolean>();
    public isCallStarted$ = this.isCallStartedBs.asObservable();

    isMicrophoneEnabled:boolean=false;
    isCameraEnabled:boolean=false;
    stream;
    peers_id;
    camaraNallow: boolean;

  time: number = 0;
  display:any="0:00";
  interval;
  dd:number=1;
    constructor(private VideoAppointmentsData:VideoAppointmentsData,private deviceService: DeviceDetectorService,private snackBar: MatSnackBar) { 
        
        // const mediaDevices = navigator.mediaDevices as any;
        // navigator.getUserMedia = mediaDevices.getUserMedia = mediaDevices.getUserMedia || mediaDevices.webkitGetUserMedia || mediaDevices.mozGetUserMedia || mediaDevices.msGetUserMedia;

    }


    public  initPeer(pid): string {
      // alert("peer= "+pid)
        if (!this.peer || this.peer.disconnected) {
            const peerJsOptions: PeerJSOption = {
                // host: '152.70.79.25',
                // port: 9005,
                // path: '/myapp',
                debug: 3,
                config: {
                  iceServers: [ 
                    {
                      urls: [ 
                        "stun:stun1.l.google.com:19302",
                        "stun:stun2.l.google.com:19302",
                        "stun:stun3.l.google.com:19302",
                        "stun:stun4.l.google.com:19302",
                        "stun:relay.backups.cz"
                      ]
                    },
                    {
                      "urls": ["turn:numb.viagenie.ca"],
                      username: 'rajamanickams1999@gmail.com',
                      credential: 'Raj@12345',
                    },
                    {
                      urls: 'turn:numb.viagenie.ca',
                      credential: 'Raj@12345',
                      username: 'Raj@12345'
                    },
                    {
                      urls: 'turn:192.158.29.39:3478?transport=udp',
                      credential: 'JZEOEt2V3Qb0y27GRntt2u2PAYA=',
                      username: '28224511:1379330808'
                    },
                    {
                      urls: 'turn:192.158.29.39:3478?transport=tcp',
                      credential: 'JZEOEt2V3Qb0y27GRntt2u2PAYA=',
                      username: '28224511:1379330808'
                    },
                    {
                      urls: 'turn:turn.bistri.com:80',
                      credential: 'homeo',
                      username: 'homeo'
                    },
                    {
                      urls: 'turn:turn.anyfirewall.com:443?transport=tcp',
                      credential: 'webrtc',
                      username: 'webrtc'
                    },
                    {
                      "urls": [
                        "turn:13.250.13.83:3478?transport=udp"
                      ],
                      "username": "YzYNCouZM1mhqhmseWk6",
                      "credential": "YzYNCouZM1mhqhmseWk6"
                    },
                    {
                      urls: 'turn:relay.backups.cz',
                      credential: 'webrtc',
                      username: 'webrtc'
                    },
                    {
                        urls: 'turn:relay.backups.cz?transport=tcp',
                        credential: 'webrtc',
                        username: 'webrtc'
                    }, 
                  ]
                    // iceServers: [
                    //     {
                    //         urls: [
                    //             'stun:stun1.l.google.com:19302',
                    //             'stun:stun2.l.google.com:19302',
                    //         ],
                    //     }
                    //   ]
                },
            };
            try {
              let id;
              if(pid=="null"){
                id = uuidv4();
              }else{
                id = pid;
                // ////alert("old id");
              }
                this.peers_id=id;
                //////console.log(id);
                this.peer = new Peer(id, peerJsOptions);
                console.error("peer ",this.peer)
                return id;
            } catch (error) {
                //////console.error(error);
            }
        }
    }
    public firstcall(connection,remotePeerId){
      connection.on('open', function(){
        //////console.log("================== Send msg1 +++++++++++++++++++++++++++");
        connection.send('Raja,'+remotePeerId);
      });
    }
    reconnect() {
      this.peer.reconnect();
    }
    public async establishMediaCall(remotePeerId: string) {
      this.meeting_start(remotePeerId,"false");
      //////console.error(this.peer)
      this.isMicrophoneEnabled=true;
      this.isCameraEnabled=true;
      this.peers_id=remotePeerId;
        try {
            this.its_host=true;
            var browser = <any>navigator;
            browser.getUserMedia = (browser.getUserMedia ||
              browser.webkitGetUserMedia ||
              browser.mozGetUserMedia ||
              browser.msGetUserMedia);
            const stream = await browser.mediaDevices.getUserMedia({ video: true, audio: true });
              /* use the stream */
              // //alert("user allowed");
            const connection = this.peer.connect(remotePeerId);
            console.log("connection = ",connection)
            this.firstcall(connection,remotePeerId);
            var data=0;
            connection.on('data', conn => {
              //////console.error("++++++++++++++++++++++++ "+conn);
            });
              // if(conn==1){
                if(true){
                this.mediaCall = this.peer.call(remotePeerId, stream);
                this.mediaCall.peerConnection.oniceconnectionstatechange =  (data) =>{
                  console.error("!! Media Call = ", this.mediaCall);
                  console.error("!! Data  =  ", data);                                   
                  // switch (connection.iceConnectionState) {
                  //   case "failed":
                  //     console.log("iceConnectionState is failed, closing connections to " );
                  //     break;             
                  //   case "closed":
                  //     console.log("iceConnectionState is closed, closing connections to " );
                  //     break;             
                  //   case "disconnected":
                  //     console.log("iceConnectionState is disconnected, closing connections to ");             
                  //     break;
             
                  // }             
                }; 
                console.log("mediaCall = ",this.mediaCall)

                if (!this.mediaCall) {
                    let errorMessage = 'Unable to connect to remote peer';
                    this.snackBar.open(errorMessage, 'Close');
                    throw new Error(errorMessage);
                }
                this.localstream=stream;
                this.localStreamBs.next(stream);
                this.isCallStartedBs.next(true);
                this.callstart=true;
                this.mediaCall.on('stream',
                    (remoteStream) => {
                      if(this.dd==1){
                        this.startTimer();
                        this.dd++;
                        }
                      this.callstart=true;
                      // this.startTimer();
                      this.remotestream=remoteStream;
                        this.remoteStreamBs.next(remoteStream);
                    });
                this.mediaCall.on('error', err => {
                    this.initPeer("null");
                    var data=this.get_data();
                    if(data[0]!=null){
                      this.establishMediaCall(data[2]);
                    }
                    // this.snackBar.open(err, 'Close');
                    //////console.error(err);
                    // connection.
                    this.isCallStartedBs.next(false);
                });
                this.mediaCall.on('close', () => {
                  //////console.error('Destroyed by sender');
                  this.onCallClose()
                });
              }
              this.camaraAllow=false;


        }
        catch (ex) {
            //////console.error(ex);
            //////console.error(ex);
            this.peer=this.peer_reconnect;
            ////alert("test")
            this.snackBar.open(ex, 'Close');
            // this.peer:Peer=;
            this.isCallStartedBs.next(false);
        }
    }



    public printpeer(){
      //////console.log(this.peer);
    }

    public async enableCallAnswer() {
      //////console.error(this.peer)
      this.meeting_start(this.peer.id,"true");
      this.isMicrophoneEnabled=true;
      this.isCameraEnabled=true;
      var check=false;
      // this.data.push({name:"Dr. Raja (me)",admited:true,"peerid":this.peers_id});
        try {


          // if(this.sec_call==1)  {
            if(true){
            var browser = <any>navigator;
            browser.getUserMedia = (browser.getUserMedia ||
              browser.webkitGetUserMedia ||
              browser.mozGetUserMedia ||
              browser.msGetUserMedia);


            let stream = await browser.mediaDevices.getUserMedia({ video: true, audio: true });
              /* use the stream */
              // //alert("user allowed")
              this.camaraAllow=true;

              this.localstream=stream;
              this.localStreamBs.next(this.localstream);
              console.log("Peers ID =",this.peer);      
            
              this.peer.on('call', async (call) => {
                  this.callstart=true;
                  this.mediaCall = call;
                  this.isCallStartedBs.next(true);
                  this.mediaCall.answer(this.localstream);

                  this.mediaCall.peerConnection.oniceconnectionstatechange =  (data) =>{
                    console.error("!! Media Call = ", this.mediaCall);
                    console.error("!! Data  =  ", data);                                   
                    // switch (connection.iceConnectionState) {
                    //   case "failed":
                    //     console.log("iceConnectionState is failed, closing connections to " );
                    //     break;             
                    //   case "closed":
                    //     console.log("iceConnectionState is closed, closing connections to " );
                    //     break;             
                    //   case "disconnected":
                    //     console.log("iceConnectionState is disconnected, closing connections to ");             
                    //     break;
               
                    // }             
                  }; 
                  
                  this.mediaCall.on('stream', (remoteStream) => {
                    if(this.dd==1){
                    this.startTimer();
                    this.dd++;
                    }
                    this.remotestream=remoteStream;
                    this.callstart=true;
                      this.remoteStreamBs.next(remoteStream);
                  });
                  this.mediaCall.on('error', err => {
                      var data=this.get_data();
                      if(data[0]!=null){
                        this.initPeer(data[2]);
                      }
                      // this.snackBar.open(err, 'Close');
                      this.isCallStartedBs.next(false);
                      //////console.error(err);
                  });
                //   this.mediaCall.on('disconnected', () => {

                //     //////console.error("Server Disconnect");
                // });
                  this.mediaCall.on('close', () => {
                    //////console.error("call close");
                    var data=this.get_data();
                    if(data[0]!=null){
                      this.initPeer(data[2]);
                      this.enableCallAnswer();
                    }
                    this.onCallClose()
                  });

              });
             
              this.peer.on('disconnected', () => {
                // alert("server disconnected");
                  var data=this.get_data();
                  if(data[0]!=null){
                    this.initPeer(data[2]);
                    this.enableCallAnswer();
                  }

              });
              this.camaraAllow=false;


          }
        }
        catch (ex) {
            //////console.error(ex);
            this.peer?.reconnect();
            this.snackBar.open(ex, 'Close');
            this.isCallStartedBs.next(false);
        }
    }


public async buttonHandler(): Promise<void> {
    // evento.preventDefault();
    const mediaDevices = navigator.mediaDevices as any;

    mediaDevices.getDisplayMedia().then(stream => {
        this.localstream = stream;
        this.localStreamBs.next(stream);
        // this.peer.call(remote_peer_key, stream);
        this.peer.on('call', call => {
          //////console.log("on call")
          call.answer(stream)
        });
        // this.peer.call(this.peers_id, this.localstream);
  })


    // this.mediaCall.answer(stream);
    // const call = this.peer.call(remotoId, stream);
}

sleep(ms) {​​​​​​​​
    return new Promise(resolve=>setTimeout(resolve, ms));
}​​​​​​​​

getData(){
  return (this.data);
}
sendData(){
  this.data.push( {name:"test"});
}
 public async enableans(){
      this.peer.on('connection', (conn) => {
        conn.on('data', async (data) => {
            // Will print 'hi!'
            //////console.log("00000000000000000000000000000000 Receive msg1 +++++++++++++++++++++++++++");
            //////console.log(data);
            //////console.error("test1="+data);
            return data;
          });
        });
    }
// await this.sleep(3000);


    public callans(id){
      ////alert("first inside function="+id);
      this.peer.on('connection', (conn)=> {
        ////alert("2 inside function="+id);
        conn.on('open', ()=>{
          ////alert("test2="+id);
          //////console.log("================== Send msg2 +++++++++++++++++++++++++++");
          conn.send(id);
        });
      });
      return true;
    }
    private onCallClose() {
      try{
        this.localStreamBs?.value.getTracks().forEach(track => {
          track.stop();
      });
      this.remoteStreamBs?.value.getTracks().forEach(track => {
          track.stop();
      });
      }catch(ex){
        console.log("Camera Not Stoped ", ex);
        
      }
      
        // this.snackBar.open('Call Ended', 'Close');
    }

    public closeMediaCall():any {
      this.meeting_end();
      this.onCallClose();
      this.mediaCall?.close();
        if (!this.mediaCall) {
            this.onCallClose()
        }
        this.isCallStartedBs.next(false);
        this.destroyPeer();
        return "200";
    }

    public destroyPeer() {
        this.callstart=false;
        this.peer?.disconnect();
        this.peer?.destroy();
       
    }

    public videoff(){

      this.data=[];
      this.localStreamBs?.value.getTracks().forEach(track => {
        track.stop();
      });
      this.remoteStreamBs?.value.getTracks().forEach(track => {
        track.stop();
      });
    }



  local_toggleVideo() {
    if(this.localstream != null && this.localstream.getVideoTracks().length > 0){
      this.local_video_switch = !this.local_video_switch;
      this.localstream.getVideoTracks()[0].enabled = this.local_video_switch;
    }

  }

  local_toggleMic() {
    if(this.localstream  != null && this.localstream .getAudioTracks().length > 0){
      this.local_mic_switch = !this.local_mic_switch;
      this.localstream .getAudioTracks()[0].enabled = this.local_mic_switch;
    }
  }


  remote_toggleVideo() {
    if(this.remotestream != null && this.remotestream.getVideoTracks().length > 0){
      this.remote_video_switch = !this.remote_video_switch;
      this.remotestream.getVideoTracks()[0].enabled = this.remote_video_switch;
    }

  }

  remote_toggleMic() {
    if(this.remotestream  != null && this.remotestream .getAudioTracks().length > 0){
      this.remote_mic_switch = !this.remote_mic_switch;
      this.remotestream .getAudioTracks()[0].enabled = this.remote_mic_switch;
    }
  }

  meeting_start(remotePeerId,host){
      localStorage.setItem("meeting_on","true");
      localStorage.setItem("its_host",host);
      localStorage.setItem("peer_id",remotePeerId);
  }
  meeting_end(){
    this.pauseTimer()
    localStorage.removeItem("meetingData");
    localStorage.removeItem("meeting_"); 
    localStorage.removeItem("meeting_on");
    localStorage.removeItem("its_host");
    localStorage.removeItem("peer_id");
    localStorage.removeItem("vctimer");
    localStorage.removeItem("MeetingDetailes");
    localStorage.removeItem("PreURL");
  }

  get_data(){
      var data1=localStorage.getItem("meeting_on");
      var data2=localStorage.getItem("its_host");
      var data3=localStorage.getItem("peer_id");
      var data=[];
      data.push(data1);
      data.push(data2);
      data.push(data3);
      return data;
  }

  async checkCameraAccess():Promise<any> {
    var StreamBs: BehaviorSubject<MediaStream> = new BehaviorSubject(null);
    var res:any;
    try{
      var browser = <any>navigator;
      browser.getUserMedia = (browser.getUserMedia ||
        browser.webkitGetUserMedia ||
        browser.mozGetUserMedia ||
        browser.msGetUserMedia);
        var stream = await browser.mediaDevices.getUserMedia({ video: true, audio: true });
        // console.log("stream= ",stream);
        if(stream!=null){
        StreamBs.next(stream);
        // stream.getTracks()[0].stop();
        StreamBs?.value.getTracks().forEach(track => {
          track.stop();
        });
        res=true;
        }else{
          res=false;
        }
    }catch(ex){
        res=false
        ////console.log(ex);
    }
    return res;
  }


 startTimer() {
  // //console.log("=====>");
  this.interval = setInterval(() => {
    var t;//=parseInt(this.getTimer()==null?0:this.getTimer());
    if(this.getTimer()!=null){
      t=parseInt(this.getTimer());
    }else{
      t=0;
    }
    this.time=t;
    // console.error("get t = ",t)
    if (this.time ===t) {
      this.time++;
    } else {
      this.time++;
    }
    this.setTimer(this.time);
    this.display=this.transform(this.time)
  }, 1000);
}
transform(value: number): string {
     const minutes: number = Math.floor(value / 60);
    var min;
     if(minutes<10){
       min='0'+String(minutes);
     }else{
      min=minutes
     }
     return min + ':' + (value - minutes * 60);
}
pauseTimer() {
  clearInterval(this.interval);
}

setTimer(time){
  localStorage.setItem("vctimer",time);
}
getTimer(){
 return localStorage.getItem("vctimer");
}

get getIP(): string { 
  // this.VideoAppointmentsData.list(`http://api.ipify.org/?format=json`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
  //   console.log("data = ",data);
  //   return data?.ip;
  //   }, (error) => {
  //   console.log("error = ",error);
  //   }, () => {
  //       return "";
  //   });
   return "";
}

get getDeviceType(): string {
return this.deviceService.getDeviceInfo()?.deviceType;
}
get getOS(): string {
return this.deviceService.getDeviceInfo()?.os+"-"+this.deviceService.getDeviceInfo()?.os_version;
}
get getBrowser(): string {
return this.deviceService.getDeviceInfo()?.browser;
}
get getBrowserVersion(): string {
return this.deviceService.getDeviceInfo()?.browser_version;
}
    // public senmsg(){
    //   var conn = this.peer.connect(this.peers_id);
    //   conn.on('open', function(){
    //     //////console.log("================== Send msg +++++++++++++++++++++++++++");
    //     conn.send('hi!');
    //   });
    // }
    // public receive(){
    //   this.peer.on('connection', function(conn) {
    //     conn.on('data', function(data){
    //       // Will print 'hi!'
    //       //////console.log("00000000000000000000000000000000 Receive msg +++++++++++++++++++++++++++");
    //       //////console.log(data);
    //     });
    //   });
    // }
    // switchMicrophone(){
    //   this.isMicrophoneEnabled = !this.isMicrophoneEnabled;
    //   this.stream.getAudioTracks()[0].enabled = this.isMicrophoneEnabled;
    // }

    // switchCamera(){
    //   this.isCameraEnabled = !this.isCameraEnabled;
    //   this.mediaCall.getVideoTracks()[0].enabled = this.isCameraEnabled;
    //   this.mediaCall.getVideoTracks()[0].enabled = this.isCameraEnabled;
    // }
}

export interface chatMesage {
  Text: string;
  ConnectionId: string;
  DateTime: Date;
}
